<template>
  <div class="main-content">
    <div class="container pt-150">
      <div class="section-content">
        <div class="row">
          <div class="col-md-12">
            <h2 class="text-theme-colored text-center">Conferma la tua iscrizione</h2>
          </div>
        </div>
      </div>
    </div>

    <section class="divider">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 pl-20 pr-20">

            <!-- LINK ASSENTE O MALFORMATO -->
            <div v-if="!PassToken">
              <h5 class="text-center">
                Questo indirizzo non contiene un codice di conferma valido.
                Apri il link che ti abbiamo inviato per email.
              </h5>
            </div>

            <!-- CONFERMA COMPLETATA -->
            <div v-else-if="activated">
              <h3 class="mt-0 mb-10 text-center">Iscrizione confermata</h3>

              <h5 class="text-center" v-if="!passwordMailFailed">
                CONTROLLA LA TUA EMAIL: ti abbiamo inviato la
                <span class="text-theme-colored">password</span>
                per accedere alla tua area personale, dove trovi già il
                programma gratuito.
              </h5>

              <h5 class="text-center" v-else>
                Il tuo account è attivo, ma non siamo riusciti a inviarti
                l'email con la password. Usa
                <a class="text-theme-colored" href="/resetpass">Recupera password</a>
                per impostarne una.
              </h5>

              <p class="text-center pt-20" v-if="!passwordMailFailed">
                Non trovi l'email? Controlla anche la posta indesiderata.
              </p>

              <div class="form-group text-center pt-20">
                <a href="/login" class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white">
                  VAI AL LOGIN
                </a>
              </div>
            </div>

            <!-- CONFERMA: UN SOLO BOTTONE -->
            <div v-else>
              <h5 class="text-center pb-20">
                Premi il pulsante per confermare la tua iscrizione: ti invieremo
                per email la password con cui accedere.
              </h5>

              <div class="row pt-10" v-if="error">
                <div class="col-md-12">
                  <div class="alert alert-danger">{{ error }}</div>
                </div>
              </div>

              <div class="form-group text-center pt-10">
                <button
                  type="button"
                  :disabled="sending"
                  @click="confirm"
                  class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white"
                >
                  {{ sending ? "ATTENDI..." : "CONFERMA ISCRIZIONE" }}
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.alert {
  width: 100%;
}
</style>

<script>
import axios from "axios";

export default {
  name: "ActivateTrial",
  props: ["PassToken"],
  data() {
    return {
      activated: false,
      passwordMailFailed: false,
      sending: false,
      error: "",
    };
  },
  methods: {
    confirm: function () {
      this.error = "";
      this.sending = true;

      axios
        .post(process.env.VUE_APP_API_URL + "/confirmTrialProgram", {
          token: this.PassToken,
        })
        .then((response) => {
          if (response.data.Ok == true) {
            this.activated = true;
            // L'account c'e' comunque: cambia solo cosa diciamo all'utente.
            this.passwordMailFailed =
              response.data.Code == "PASSWORD_MAIL_NOT_SENT";
          }
          else {
            this.error = response.data.Error || "Conferma non riuscita.";
          }
        })
        .catch((err) => {
          console.log(err);
          // Il backend risponde 429 con un messaggio quando scatta il rate limit.
          var serverError =
            err.response && err.response.data && err.response.data.Error;

          this.error =
            serverError || "Conferma non riuscita, riprova tra qualche minuto.";
        })
        .then(() => {
          this.sending = false;
        });
    },
  },
};
</script>
